import SentimentInput from './SentimentInput';

export default function StarsInput(props: { name: string; initialValue?: number }) {
	return (
		<SentimentInput
			name={props.name}
			suffix="stars"
			choices={['⭐', '⭐', '⭐', '⭐', '⭐']}
			accumulative
			initialValue={props.initialValue}
		/>
	);
}
